import { useLayoutEffect } from 'react'
import { AxiosResponse } from 'axios'

import { useAxiosInstance } from './AxiosInstanceProvider.js'

export const useResponseInterceptor = (
  onFulfilled?: (value: AxiosResponse) => AxiosResponse | Promise<AxiosResponse>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onRejected?: (errorResponse: any) => any
): void => {
  const axiosInstance = useAxiosInstance()

  useLayoutEffect(() => {
    const id = axiosInstance.interceptors.response.use(onFulfilled, onRejected)

    return () => {
      axiosInstance.interceptors.response.eject(id)
    }
  }, [axiosInstance, onFulfilled, onRejected])
}
